import { AuthLayout } from '../../components/AuthLayout/AuthLayout';
import Page from '../../components/Page/Page';
import { ResetPassword } from '../../sections/auth/ResetPassword';

export default function ForgotPassword() {
  return (
    <Page title="Darum | Reset Password">
      <AuthLayout
        label="Already have an account?"
        linkTitle="Log In"
        linkPath="/account/signin"
        formHeaderTitle="Forgot Password"
        formHeaderDescription="A reset password will be sent to the email associated with your account."
      >
        <ResetPassword />
      </AuthLayout>
    </Page>
  );
}
